import * as React from 'react'
import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { getTouchedObject } from '@sales-center/common'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { EditActivityForm } from '../typings'

type Props = {
  onCancelClick: () => void
}

export function ActivityFormActions(props: Props) {
  const { onCancelClick } = props

  const { setTouched, errors, submitForm } =
    useFormikContext<EditActivityForm>()

  const handleSaveClick = useCallback(() => {
    if (errors && Object.keys(errors).length > 0) {
      setTouched(getTouchedObject(errors))
    } else {
      submitForm()
    }
  }, [errors, setTouched, submitForm, getTouchedObject])

  return (
    <Stack direction="row" spacing={1} justifyContent="end" pt={2}>
      <Button fullWidth size="small" onClick={onCancelClick}>
        <Typography minWidth={110}>Cancel</Typography>
      </Button>
      <Button
        fullWidth
        size="small"
        variant="contained"
        onClick={handleSaveClick}
      >
        <Typography minWidth={110}>Save</Typography>
      </Button>
    </Stack>
  )
}
